import React from 'react';

export function SortableTh({ label, sortKey, activeKey, sortDir, onSort, style, className }) {
  if (!sortKey || !onSort) {
    return <th style={style} className={className}>{label}</th>;
  }
  const active = activeKey === sortKey;
  const arrow = active ? (sortDir === 'asc' ? ' ↑' : ' ↓') : '';
  return (
    <th
      style={{ ...style, cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
      className={className}
      onClick={() => onSort(sortKey)}
      title="Sort"
    >
      {label}{arrow}
    </th>
  );
}

export default SortableTh;
